import { useVideo } from '../hooks/useVideo';
import type { VideoPlayer } from '../VideoTypes';

// https://regex101.com/r/wdKKHO/1
const VIMEO_REGEX = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;

function VimeoPlayer({ width, height, autoPlay, loop, playsInline, src, description, blockClass }: VideoPlayer) {
	const params = `autoplay=${autoPlay}&loop=${loop}&playsinline=${Boolean(playsInline)}&enablejsapi=1&iv_load_policy=3&modestbranding=1`;
	const { componentId } = useVideo();
	const matchedSrc = src.match(VIMEO_REGEX);
	const videoId = matchedSrc?.[5];

	return (
		<div
			data-selection={componentId}
			className={`relative videoContainer vtex-store-video-1-x-videoContainer ${blockClass ? `videoContainer--${blockClass} vtex-store-video-1-x-videoContainer--${blockClass}` : ''}`}
		>
			<iframe
				data-testid="vimeo-player"
				width={width}
				height={height}
				title={description}
				className={`videoElement vtex-store-video-1-x-videoElement ${blockClass ? `videoElement--${blockClass} vtex-store-video-1-x-videoElement--${blockClass}` : ''}`}
				src={`https://player.vimeo.com/video/${videoId}?${params}`}
				frameBorder="0"
				allowFullScreen
				allow="autoplay"
			/>
		</div>
	);
}

export default VimeoPlayer;
